import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { FirebaseContext } from '../components/firebase/FirebaseProvider';

const withFirebase = (WrappedComponent) => {
    class FirebaseConsumer extends React.PureComponent {
        render () {
            return (
                <FirebaseContext.Consumer>
                    {({ firebase, database, performance, storage }) => (
                        <WrappedComponent {...this.props} firebase={firebase} database={database} firebasePerformance={performance} firebaseStorage={storage} />
                    )}
                </FirebaseContext.Consumer>
            );
        }
    }
    return hoistNonReactStatics(FirebaseConsumer, WrappedComponent);
};

export default withFirebase;
